import React from "react";
import { SchedulerContainer } from "../../../containers";

const Scheduler = (props) => {
  return <SchedulerContainer {...props} />;
};

export default Scheduler;
